<div class="export-epg-screen-container">
  <div class="export-epg-screen">
    <h1>Export EPG</h1>
    <h2>Please select your export preferences</h2>

    <div class="date-picker-epg-container">
      <label class="epg-option"> SELECT DATE RANGE: </label>
      <div class="date-picker-epg-content">
        <label class="epg-option-inline">From: </label>
        <dateinput
          [(current)]="startDate"
          (currentChange)="changeStartDate($event)"
        ></dateinput>
        <label class="epg-option-inline">To: </label>
        <dateinput
          [(current)]="endDate"
          (currentChange)="changeEndDate($event)"
        ></dateinput>
      </div>
    </div>

    <div class="media-duration-container">
      <label class="epg-option">MEDIA DURATION:</label>
      <div class="media-duration-content">
        <label class="epg-option-inline">For Media Longer Than</label>
        <input type="text" [(ngModel)]="minDuration" />
        <label class="epg-option-inline">Min</label>
      </div>
    </div>
    <div class="platforms-export-container" *ngIf="exportFormat === 'csv'">
      <label class="epg-option"> EXPORT PLATFORM: </label>
      <icn-dropdown
        class="export-platforms-dropdown"
        [selectedValue]="exportConfigurationChosen"
        (selectedValueChange)="onSelectedExportConfigurationChange($event, platformsPopover)"
      >
        <icn-dropdown-item
          *ngFor="let configuration of exportConfigurations"
          [title]="configuration.name"
          [value]="configuration"
        >
        </icn-dropdown-item>
      </icn-dropdown>
      <div
        class="svg-icon-export"
        inlineSVG="/assets/icons/add-account.svg"
        (click)="onClickAddPlatform($event, platformsPopover)"
      ></div>
      <pop-over #platformsPopover [my]="'left'" [at]="'left'" [x-offset]="60">
        <icn-export-platforms
          (addedExportConfiguration)="onAddedExportConfiguration($event,platformsPopover)"
          (updatedExportConfiguration)="onUpdatedExportConfiguration($event,platformsPopover)"
          (close)="onPlatformsClose(platformsPopover)"
        ></icn-export-platforms>
      </pop-over>
    </div>

    <div class="xml-checkbox-container">
      <evrideo-checkbox
        (activeChange)="onXMLCheckboxCheck($event)"
      ></evrideo-checkbox>
      <label class="epg-option-inline spaced">Export as XML</label>
    </div>

    <a class="btn btn-export" (click)="exportEpg()" download>Export</a>
  </div>
</div>
